import { KeywordsPipelineInfoDialogProvider } from "contexts/KeywordsPipelineInfoDialogContext";
import { ProductNavigationBarContent } from "./ProductNavigationBarContent";

export const ProductNavigationBar = () => (
  <KeywordsPipelineInfoDialogProvider>
    <ProductNavigationBarContent />
  </KeywordsPipelineInfoDialogProvider>
);
